/**
 * テナントの状態（trial/active/suspended・03 §8 ライフサイクル）の表示。
 *
 * backend は英語の status を返す（05 §4.7）。運営に見せるのは日本語ラベル＝
 * 一覧と詳細で**同じ語・同じ色**にするため、対応は1か所に集約する。
 */

import type { BadgeTone } from "@kenzai/ui";

const LABEL: Record<string, string> = {
  trial: "試用",
  active: "稼働中",
  suspended: "停止中",
};

const TONE: Record<string, BadgeTone> = {
  trial: "neutral",
  active: "ok",
  suspended: "danger",
};

/** 未知の値は生のまま出す（嘘の日本語に置き換えない）。 */
export function tenantStatusLabel(status: string): string {
  return LABEL[status] ?? status;
}

export function tenantStatusTone(status: string): BadgeTone {
  return TONE[status] ?? "neutral";
}
